function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18.5,
  fill: "#2C2B6C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7506 21.5072L11.0949 22.0438L11.8816 22.3584L18.9489 25.1854L19.2228 25.2949L19.4512 25.1081L24.6339 20.8677L25.2896 20.3312L24.503 20.0165L17.4356 17.1896L17.1617 17.08L16.9333 17.2668L11.7506 21.5072Z",
  stroke: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1346 24.7211L5 19.0673L29.5 16.2404L19.1346 24.7211Z",
  fill: "#2C2B6C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7506 18.6803L11.0949 19.2168L11.8816 19.5315L18.9489 22.3584L19.2228 22.468L19.4512 22.2812L24.6339 18.0408L25.2896 17.5043L24.503 17.1896L17.4356 14.3627L17.1617 14.2531L16.9333 14.4399L11.7506 18.6803Z",
  fill: "#CBCBCB",
  stroke: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1346 21.8942L5 16.2404L29.5 13.4135L19.1346 21.8942Z",
  fill: "#2C2B6C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7506 15.8534L11.0949 16.3899L11.8816 16.7046L18.9489 19.5315L19.2228 19.6411L19.4512 19.4543L24.6339 15.2139L25.2896 14.6774L24.503 14.3627L17.4356 11.5358L17.1617 11.4262L16.9333 11.613L11.7506 15.8534Z",
  fill: "white",
  stroke: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 12.5,
  stroke: "white",
  strokeWidth: 2
});

function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.252b3922.svg";
export { ForwardRef as ReactComponent };